import { useTranslation } from 'react-i18next'

import { DateTimePicker } from '../../../../../DateTime'
import { FieldStackedLabel } from '../../../../../Field'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'

import { getDeadlineFieldTexts } from './DeadlineValueField.utils'

import * as styles from '../../../ConnectedRequestsMassEditModal.module.css'

function DeadlineValueField({ name }) {
  const { t } = useTranslation()

  const { dateLabel, datePlaceholder, timeLabel, timePlaceholder } =
    getDeadlineFieldTexts(t)

  return (
    <FormikField
      Component={DateTimePicker}
      Field={FieldStackedLabel}
      dateProps={{
        label: dateLabel,
        placeholder: datePlaceholder,
        wrapperClassName: styles.dateTimeInput,
      }}
      fieldComponentProps={{
        className: styles.valueFieldStackedLabel,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={name}
      timeProps={{
        label: timeLabel,
        placeholder: timePlaceholder,
        wrapperClassName: styles.dateTimeInput,
      }}
    />
  )
}

export default DeadlineValueField
